/* eslint-disable no-unused-vars */
import React from 'react';
import { Network, Building2, Heart, ShoppingCart, Phone, Factory } from 'lucide-react';

function Layer3() {
  const sectors = [
    {
      title: "IT & ITES",
      description: "Our data point validation enables IT & ITES industries to make compliant informed decisions.",
      icon: (
        <Network className="w-10 h-10 text-red-500 stroke-[1] transition-all duration-300 group-hover:text-white group-hover:scale-125" />
      ),
            image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=1000",
      route: "/it-services"
    },
    {
      title: "Banking & Financial Services",
      description: "Criterion provides accurate employee background check reports assuring the banking sector peace of mind with safe hire.",
      icon: <Building2 className="w-10 h-10 text-red-500 stroke-[1] transition-all duration-300 group-hover:text-white group-hover:scale-125" />,
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1000",
      route: "/banking-services"
    },
    {
      title: "Health Care",
      description: "Criterion employee background verification ensures a reliable environment in the healthcare industry.",
      icon: <Heart className="w-10 h-10 text-red-500 stroke-[1] transition-all duration-300 group-hover:text-white group-hover:scale-125" />,
      image: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?auto=format&fit=crop&q=80&w=1000",
      route: "/health-services"
    },
    {
      title: "E-Commerce",
      description: "Criterion platform gives you the speed to handle high attrition and be future empowered.",
      icon: <ShoppingCart className="w-10 h-10 text-red-500 stroke-[1] transition-all duration-300 group-hover:text-white group-hover:scale-125" />,
      image: "https://images.unsplash.com/photo-1472851294608-062f824d29cc?auto=format&fit=crop&q=80&w=1000",
      route: "/ecommerce-services"
    },
    {
      title: "Telecom",
      description: "Criterion platform gives you the speed to handle high attrition and be future empowered.",
      icon: <Phone className="w-10 h-10 text-red-500 stroke-[1] transition-all duration-300 group-hover:text-white group-hover:scale-125" />,
      image: "https://images.unsplash.com/photo-1483478550801-ceba5fe50e8e?auto=format&fit=crop&q=80&w=1000",
      route: "/telecom-services"
    },
    {
      title: "Manufacturing / Automobile",
      description: "Our data point validation enables organizations to make compliant informed decisions.",
      icon: <Factory className="w-10 h-10 text-red-500 stroke-[1] transition-all duration-300 group-hover:text-white group-hover:scale-125" />,
      image: "https://images.unsplash.com/photo-1537462715879-360eeb61a0ad?auto=format&fit=crop&q=80&w=1000",
      route: "/manufacturing-services"
    },
  ];

  return (
    <div className="min-h-screen bg-black select-none">
        <h1 className='text-white text-center pt-20 text-3xl'>Our {" "}
            <span className="text-[#b7372e] font-bold">Industry Solution</span>
        </h1>
      <div className="container mx-auto px-4 py-16 max-w-[1200px]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sectors.map((sector, index) => (
            <div
              key={index}
              className="group relative overflow-hidden bg-[#141414] border border-white/20 rounded-lg aspect-square cursor-pointer"
            >
              {/* Background Image with Overlay */}
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{
                  backgroundImage: `linear-gradient(rgba(220, 38, 38, 0.8), rgba(220, 38, 38, 0.8)), url(${sector.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />

              {/* Content */}
              <div className="relative h-full p-8 flex flex-col">
                <h3 className="text-2xl font-bold text-white mb-4">{sector.title}</h3>
                <p className="text-gray-400 group-hover:text-white transition-colors duration-300 mb-auto italic">
                  {sector.description}
                </p>

                {/* Bottom Row: Icon and Arrow */}
                <div className="flex items-center justify-between mt-6">
                  <div>{sector.icon}</div>
                  <a href={sector.route} className="text-white">
                    <svg
                      className="w-8 h-8 text-red-500 group-hover:text-white transition-transform duration-300 transform group-hover:translate-x-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth={0.75}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 12h20m0 0l-4-4m4 4l-4 4"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Layer3;
